let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("66kwt")).then(() => parcelRequire('6x6fb'));